import { makeActions } from 'redux/crudCreator/actions';

export const MODEL_NAME = 'platforms';
export const platformsActions = makeActions(MODEL_NAME);

export const getAllPlatforms = platformsActions.getAll;
export const editPlatforms = platformsActions.edit;
export const createPlatforms = platformsActions.create;
export const getByIdPlatforms = platformsActions.getDataById;
